import { useForm } from '@mantine/form';
import { useState } from 'react';
import {
	validateNotEmpty,
	validateNumber,
} from '../../../util/validation/commonValidation';
import type { PercentagePriceChangeDto } from '../types/ProductPriceDto';

const defaultPercentage: PercentagePriceChangeDto = {
	allSelected: false,
	keys: [],
	percentage: 0,
	roundingMode: 'nearest',
};

export function usePercentagePriceChangeForm() {
	const [inputs, setInputs] = useState<PercentagePriceChangeDto>(defaultPercentage);

	const form = useForm<PercentagePriceChangeDto>({
		mode: 'uncontrolled',
		initialValues: inputs,
		validate: {
			percentage: (v) =>
				validateNumber(v?.toString(), false, -100, 1000, 'Percentage', false),
			roundingMode: (v) => validateNotEmpty(v, 'Rounding mode'),
		},
		onValuesChange: (v) => setInputs(v),
	});

	return { form, inputs };
}